import { Auth } from 'aws-amplify';
import { useState } from 'react';
import { useForm } from 'react-hook-form'

import { emailTestRegex } from "./details";

type ExistingUserProps = {
  email?: string;
  viaError: boolean;
  refresh: () => void;
}

export default function ExistingUser(props: ExistingUserProps) {
  const [signInError, setError] = useState(null)
  const loginForm = useForm({
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: {
      email: props.email,
      password: ''
    }
  })

  const { formState: { errors: loginErrors } } = loginForm;

  const registerLoginEmail = loginForm.register('email', {
    required: true,
    shouldUnregister: false,
    validate: {
      email: (v: string) => emailTestRegex.test(v)
    }
  });

  async function processLogin(data, action) {
    try {
      setError(null)

      const signInResult = await Auth.signIn({
        username: data.email.toLowerCase(),
        password: data.password,
      })

      props.refresh()
      loginForm.reset()
    } catch (err) {
      console.log(err, err.message)
      setError(err.message)
    }
  }

  return (
    <form onSubmit={loginForm.handleSubmit((p) => processLogin(p, close))}>
      <div className="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4">
        {props.viaError && <p className="sm:col-span-2 text-gray-900 text-sm font-medium">This email is already registered. Please sign in to continue</p>}

        {signInError && (
          <p className='sm:col-span-2 text-sm font-medium text-red-400'>{signInError}</p>
        )}

        <div className="">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
            Email
          </label>
          <div className="mt-1">
            <input
              type="text"
              id="email"
              {...registerLoginEmail}
              autoComplete="email"
              className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
            />
            {loginErrors.email && loginErrors.email.type === 'required' && (
              <span className='text-xs text-red-400'>Email is required</span>
            )}
            {loginErrors.email && loginErrors.email.type === 'email' && (
              <span className='text-xs text-red-400'>Email address is invalid</span>
            )}
          </div>
        </div>

        <div className="">
          <label htmlFor="password" className="block text-sm font-medium text-gray-700">
            Password
          </label>
          <div className="mt-1">
            <input
              type="password"
              id="password"
              {...loginForm.register('password', { required: true })}
              autoComplete="tel"
              className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
            />
            {loginErrors.password && loginErrors.password.type === 'required' && (
              <span className='text-xs text-red-400'>Password is required</span>
            )}
          </div>
        </div>
      </div>
      <div className='grid grid-cols-2 gap-4 mt-4 items-center'>
        <div>
          <p className="sm:col-span-2 text-gray-900 text-sm">Forgot your password? <a href="/forgot-password/" className='font-medium'>Reset it here</a></p>
        </div>
        <div>
          <button type='submit' className='btn-primary'>Sign in</button>
        </div>
      </div>
      <div className="clear-both" />
    </form>
  )
}
